import React, { useState, useContext } from 'react';
import { Container, Col, Spinner, Button } from 'react-bootstrap';
import axios from "axios";
import $ from 'jquery';
import { AppContext } from '../App';
import { apiRequest } from '../utils/apiHelper';


export const Staff = () => {
	const { link, accessToken, setAccessToken, staff, setStaff, getStaffLoad } = useContext(AppContext);
	const [staffConnectLoad, setStaffConnectLoad] = useState(false);
	const [connectId, setConnectId] = useState();
	function errorAlert() {
		$.alert({
			title: 'Encountered an error!',
			content: 'Something went wrong',
			type: 'red',
			typeAnimated: true,
			buttons: {
				close: function () {
				}
			}
		});
	}
	const connectStaff = (sid, status) => {
		setConnectId(sid);
		setStaffConnectLoad(true);
		apiRequest({
			url: `${link}api/cs/connect/staff/`,
			method: 'POST',
			data: {
				staff_id: sid.substring(1),
				status: status,
			},
			token: accessToken,
			setLoading: setStaffConnectLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setStaff(data);
				setConnectId();
			},
			onError: () => {
				setConnectId();
				errorAlert();
			}
		});
	}
	return (
		<Container className="py-3">
			<Col xs={12} sm={12} md={12} lg={12} className='bdr2 br-3 mb-3' >
				<Col xs="12" sm="12" md="12" lg="12" className="staff-type-header bgs1 d-grid p-2 bdrb2" >
					<span>{getStaffLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Support Staffs.'}</span>
				</Col>
				{
					staff !== undefined ? (
						Object.keys(staff).length > 0 ? (
							Object.keys(staff).map((stf, stf_i) => (
								<div className="staff-item px-3 py-1 bdrb2">
									<div className="sataff-name">
										<span>{staff[stf].username}</span>
										{
											staff[stf].connected ? (
												<span className="sucess-tag mx-2" ><i className="bi bi-check-circle-fill"></i> Connected</span>
											) : ''
										}
									</div>
									<div className="staff-option">
										{
											staffConnectLoad && connectId !== undefined && connectId === stf ? (
												<Button className="btn-t1-r self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
											) : (
												staff[stf].connected ? (
													<Button onClick={() => { connectStaff(stf, false) }} className="btn-disable self-center d-grid">Disconnect</Button>
												) : (
													<Button onClick={() => { connectStaff(stf, true) }} className="btn-enable self-center d-grid">Connect</Button>
												)
											)
										}
									</div>
								</div>
							))
						) : (<span className="tp3 p-3" >Nothing to renew.</span>)
					) : (<span className="tp3 p-3" >Fetching data...</span>)
				}
			</Col>
		</Container>
	)
}
